import type { VaFlowResponse } from '../../../services/vaMonitoringOverview';
import type { OverTimeChartData } from './overTimeRows.ts';
import { buildPerPersonChart } from './perPersonRows.ts';

const DUE_LINE = { label: 'Due', color: '#4B5563' };
const TREATED_LABEL = 'Treated';

export function buildVaFlowChart(data: VaFlowResponse): OverTimeChartData {
    const series = data.series.map((point) => ({
        bucketStart: point.bucketStart,
        total: point.treated,
        counts: point.treatedBy
    }));
    const chart = buildPerPersonChart({ people: data.people, series }, data.bucket, 'events');
    return {
        ...chart,
        rows: chart.rows.map((row, index) => ({ ...row, line: data.series[index].due })),
        totalLabel: TREATED_LABEL,
        line: DUE_LINE
    };
}
